import { prescribedProductClient } from '@/api/prescribedProducts/prescribedProductClient';
import { QueryKey } from '@/data/query';
import { getAuthData } from '@/data/service/authService';
import { Logger } from '@/utils/logger';
import type { PrescribedMedicationRequestParamsInputSchema } from '@montugroup/prescription-contracts';
import { useEffect, useMemo } from 'react';

const logger = new Logger('useGetPrescribedProducts');

export const useGetPrescribedProducts = (payload: PrescribedMedicationRequestParamsInputSchema) => {
  const { isDoc } = getAuthData();
  const queryKey = useMemo(() => [QueryKey.PrescribedProducts, payload], [payload]);

  const data = prescribedProductClient.getPrescribedMedications.useQuery({
    queryKey,
    queryData: {
      params: { ...payload },
    },

    enabled: isDoc,
    // refetch updated previously prescribed products on multiple tabs refocus
    refetchOnWindowFocus: true,
    refetchOnMount: true,
  });

  useEffect(() => {
    if (isDoc && data.isFetched && !data.isFetching && !data.data) {
      // If there are no prescribed medications, data should still contain empty arrays in response object
      // Initiated from a support ticket (B2C-8044) due to a doctor not being able to prescribe to a patient
      logger.error('No data returned from prescribed products despite successful fetch', {
        queryKey,
        meta: {
          isDoc,
          data: data.data,
          status: data.status,
        },
      });
    }
  }, [isDoc, data, data.data, data.isFetched, data.isFetching, queryKey]);

  return data;
};
